<template>
  <dr-content-item-component
    v-if="!isInEditorMode && isVisible"
    :class="evaluateClasses(classes)"
    v-bind="$props"
    @callDataSourceAction="$emit('callDataSourceAction', $event)"
  ></dr-content-item-component>
  <dr-content-item-editor
    v-else-if="isInEditorMode"
    :class="evaluateClasses(classes)"
    v-bind="$props"
    @deleteComponent="$emit('deleteComponent', $event)"
    @modelChanged="$emit('modelChanged', $event)"
  ></dr-content-item-editor>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import inputMixin from '../../mixins/input-mixin'
import drContentItemEditor from './dr-content-item-editor'
import drContentItemComponent from './dr-content-item-component'
import { EventBus } from '../../index'

export default {
  mixins: [mixin, inputMixin, widgetsWrapperMixin],
  props: ['model', 'dataSource'],
  components: {
    drContentItemEditor,
    drContentItemComponent
  },
  created() {
    EventBus.$on('createSnippet', (payload) =>
      this.$emit('createSnippet', payload)
    )
  }
}
</script>
